module.exports = __webpack_public_path__ + "static/media/icon_shopping-cart.947aa5a3.svg";